const asCount = (value) => {
  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? count : 0;
};

export const wacheSummaryItems = (summary = {}) => [
  {
    label: "Wachabteilungen",
    value: asCount(summary.departments_total),
    tone: "neutral",
  },
  {
    label: "Aktive Verträge",
    value: asCount(summary.active_contracts),
    tone: "positive",
  },
  {
    label: "Offen",
    value: asCount(summary.pending_contracts),
    tone: "warning",
  },
  {
    label: "Gesperrt",
    value: asCount(summary.blocked_contracts),
    tone: "danger",
  },
];
